import { AgvanceAPI, SkyAPI, UserAPI } from "@ai360/core";

import { AgvanceUtils } from "./agvance-utils";

export const isLinkedProductOnlyEnabled = (
    user: Pick<UserAPI.IUser, "linkedProductOnly"> | null,
    personalityId: number
): boolean => Boolean(user?.linkedProductOnly && AgvanceUtils.isAgvanceConnected(personalityId));

export const toAgvanceLocationIds = (locations: SkyAPI.ILocationResponse[] | null): string[] =>
    (locations ?? []).map((location) => location.agvanceLocationId).filter(Boolean);

export const toAgvanceLocationGuids = (locations: SkyAPI.ILocationResponse[] | null): string[] =>
    (locations ?? []).map((location) => location.locationGuid).filter(Boolean);

export const toLinkedProductGuids = (products: AgvanceAPI.IProduct[] | null): string[] =>
    (products ?? []).map((product) => product.mappingGuid).filter(Boolean);

/**
 * Narrows a list to the Agvance-linked products. Null set means unrestricted. Falsy guids are kept
 * (the equation filter's empty option, which is what makes a filter optional), as are retainGuids.
 */
export const filterLinkedProducts = <T>(
    items: T[],
    linkedProductGuids: Set<string> | null,
    getGuid: (item: T) => string,
    retainGuids?: Iterable<string>
): T[] => {
    if (linkedProductGuids == null) {
        return items ?? [];
    }
    const retained = new Set(retainGuids ?? []);
    return (items ?? []).filter((item) => {
        const guid = getGuid(item);
        return !guid || linkedProductGuids.has(guid) || retained.has(guid);
    });
};
